import Vue from "vue";
import Router from "vue-router";
import routes from "./routes";
import routesTenant from "./routesTenant";
import routesAdmin from "./routesAdmin";
import routesCustomer from "./routesCustomer";
import store from "@/store";
import { getToken, setToken, getMenu, removeToken,setDescription,setIds } from "@/utils/setToken";

Vue.use(Router);
var router = new Router({
  mode: "history",
  // base: "/zh", // 设置基础路径
  routes,
});



let token = getToken("token");
let menu = getMenu("menu");
if (token && menu) {
  if (menu === "tenant") {
    // routesTenant.forEach((route) => {
    //   const isRouteExists = router.options.routes.some((existingRoute) => {
    //     return existingRoute.path === route.path;
    //   });
    //   if (!isRouteExists) {
    //     router.options.routes.push(route);
    //   }
    // });
    routesTenant.forEach((route) => {
      router.options.routes.push(route);
    });
  } else if (menu === "sysadmin") {
    routesAdmin.forEach((route) => {
      router.options.routes.push(route);
    });
  } else {
    routesCustomer.forEach((route) => {
      router.options.routes.push(route);
    });
  }
  router.matcher = new Router({
    routes: router.options.routes,
    mode: "history",
  }).matcher;
}
router.beforeEach(async (to, from, next) => {
  let token = store.state.auth.token;
  let name = store.state.auth.curUserInfo;
  if (token) {
    // if (store.dispatch("getUserTokenAccessEnabled")) {
    if (to.path == "/login") {
      next("/home");
    } else {
      let toPath = to.path;
      if (name) {
        if (
          store.state.auth.token &&
          store.state.auth.token1 &&
          store.state.auth.token !== store.state.auth.token1
        ) {
          if (
            toPath.indexOf("devices") === 1 ||
            toPath.indexOf("details") === 1
          ) {
            setToken("token", store.state.auth.token1);
            setDescription("description", store.state.auth.curUserInfo.additionalInfo.description);
            setIds("ids", store.state.auth.curUserInfo.additionalInfo.ids);
          } else {
            setToken("token", store.state.auth.token);
          }
        }
        next();
      } else {
        // try {
        //   await store.dispatch("getCurrentUserInfo");
        //   next();
        // } catch (error) {
        store.dispatch("userLogout");
        next("/login");
        // }
      }
    }
  } else {
    let toPath = to.path;
    if (
      toPath.indexOf("home") != -1 ||
      toPath.indexOf("customers") != -1 ||
      toPath.indexOf("devices") != -1 ||
      toPath.includes("settings")
    ) {
      next("/login");
    } else {
      next();
    }
  }
});

// window.addEventListener("beforeunload", () => {
//   const token = getToken("token");
//   if (token) {
//     // 在刷新或关闭页面时清除 token
//     localStorage.removeItem("token");
//   }
// });

export default router;
